import { put, call } from 'redux-saga/effects';
import { Types } from './actions';
import ReinforcementDataRepository from '../../../../data/repositories/ReinforcementDataRepository';
import ReinforcementRepository from '../../../repositories/ReinforcementRepository';

export default function* execute(): any {
  try {
    yield put({ type: Types.GET_REINFORCEMENT_REQUEST });
    const reinforcementRepository: ReinforcementRepository =
      new ReinforcementDataRepository();
    const reinforcementResponse = yield call(
      reinforcementRepository.getReinforcements
    );

    const reinforcements: any[] = (
      reinforcementResponse?.subscribedToSchedule || []
    ).map((r: any) => {
      const arrayDate = r.date.split('-');
      const stdate = `${arrayDate[0]}/${arrayDate[1]}/${arrayDate[2]}`;
      return {
        start: new Date(`${stdate} ${r.startTime}`).getTime(),
        end: new Date(`${stdate} ${r.endTime}`).getTime(),
        date: new Date(stdate).getTime(),
        professor: r.professor,
        name: r.name,
        idZoom: r.link || '',
        type: 'R',
        eventId: r?.id,
        modality: r?.modality?.idModality,
        isReprog: r?.isRescheduled,
        classroomCode: r?.classroomCode || ''
      };
    });
    const data = {
      subscriptions: reinforcements
    };
    yield put({ type: Types.GET_REINFORCEMENT_SUCCESS, data });
  } catch (error) {
    yield put({
      type: Types.GET_REINFORCEMENT_FAILURE,
      error: 'Ocurrió un error'
    });
    throw error;
  }
}
